import {EaProjectService} from "./service/api/ea-project.service";
import {EaSourceFileService} from "./service/api/ea-source-file.service";
import {EaAnalysisResultService} from "./service/api/ea-analysis-result.service";
import {EaColumnService} from "./service/api/ea-column.service";
import {EaModelDraftService} from "./service/api/ea-model-draft.service";
import {EaModelDraftFieldService} from "./service/api/ea-model-draft-field.service";
import {EaImportConfigDraftService} from "./service/api/ea-import-config-draft.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {
    EaProjectObjectComponent
} from "./component/object-components/ea-project-object-component/ea-project-object.component";
import {
    EaAnalysisObjectComponent
} from "./component/object-components/ea-analysis-object-component/ea-analysis-object.component";
import {
    EaModelDraftObjectComponent
} from "./component/object-components/ea-model-draft-object-component/ea-model-draft-object.component";
import {
    EaImportConfigObjectComponent
} from "./component/object-components/ea-import-config-object-component/ea-import-config-object.component";

export const EA_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['ea.EaProject', {route: '/ea/project', service: EaProjectService, objectComponent: [{component: EaProjectObjectComponent}]}],
            ['ea.EaSourceFile', {route: '/ea/eaSourceFiles', service: EaSourceFileService}],
            ['ea.EaAnalysisResult', {route: '/ea/eaAnalysisResults', service: EaAnalysisResultService, objectComponent: [{component: EaAnalysisObjectComponent}]}],
            ['ea.EaColumn', {route: '/ea/eaColumns', service: EaColumnService}],
            ['ea.EaModelDraft', {route: '/ea/eaModelDrafts', service: EaModelDraftService, objectComponent: [{component: EaModelDraftObjectComponent}]}],
            ['ea.EaModelDraftField', {route: '/ea/eaModelDraftFields', service: EaModelDraftFieldService}],
            ['ea.EaImportConfigDraft', {route: '/ea/eaImportConfigDrafts', service: EaImportConfigDraftService, objectComponent: [{component: EaImportConfigObjectComponent}]}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
